"use client";

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VCard from "vcard-creator";
import { faAddressCard } from "@fortawesome/sharp-light-svg-icons";
import Link from "next/link";

interface EmployeeCardProps {
  employee: {
    image?: {
      mdUrl?: string;
      aspectRatio?: string;
    };
    displayName?: string;
    jobTitle?: string;
    phone: {
      number: string;
      isMobile: boolean;
    };
    email: string;
  };
}

const EmployeeCard: React.FC<EmployeeCardProps> = ({ employee }) => {
  return (
    <div className="md:h-full flex flex-col">
      <div
        style={
          {
            "--aspect-ratio": employee?.image?.aspectRatio,
          } as React.CSSProperties
        }
        className={`${employee?.image?.aspectRatio ? `aspect-[var(--aspect-ratio)]` : "h-[18rem]"} relative`}
      >
        {employee?.image?.mdUrl && (
          <img
            src={employee?.image?.mdUrl}
            alt="employee image"
            className="object-cover absolute inset-0 w-full h-full"
          />
        )}
      </div>
      <div className="p-4 flex flex-col gap-4 homepage-text-sm flex-1 justify-between">
        <div className="flex gap-4 items-center justify-between">
          <div className="flex flex-col">
            <span className="homepage-text-lg leading-4">
              {employee?.displayName}
            </span>
            <span className="leading-4">{employee?.jobTitle}</span>
          </div>
          <button
            aria-label="vcard"
            onClick={() => {
              const vCard = new VCard();
              vCard.addName(employee?.displayName);
              if (employee?.jobTitle) {
                vCard.addRole(employee?.jobTitle);
              }
              if (employee?.image?.mdUrl) {
                vCard.addPhotoURL(employee?.image?.mdUrl);
              }
              if (employee?.email) {
                vCard.addEmail(employee?.email);
              }
              if (employee?.phone) {
                vCard.addPhoneNumber(employee?.phone.number);
              }
              const blob = new Blob([vCard.toString()], {
                type: "text/vcard",
              });
              const url = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `${employee?.displayName}.vcf`;
              link.click();
              URL.revokeObjectURL(url);
            }}
          >
            <FontAwesomeIcon className="size-5" icon={faAddressCard} />
          </button>
        </div>
        <div className="flex flex-col">
          {employee?.phone?.number && (
            <Link href={`tel:${employee?.phone?.number}`}>
              <span>{employee?.phone?.number}</span>
            </Link>
          )}

          {employee?.email && (
            <Link href={`mailto:${employee?.email}`}>
              <span>{employee?.email}</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;
